import moment from "moment";

import APIAuth from "@/services/APIAuth.js";
import APIPortal from "@/services/APIPortal.js";

import router from '@/router/index.js';
import Session from '@/session/Session.js'

var utils = {

  PORTAL_CHANNEL: 900,
  ATTENCION_OFICINA: 9000,
  ATTENCION_CALL_ME: 9001,
  ATTENCION_TELECONF: 9002,


  validaNIF(value) {
    // return true
    /* eslint-disable */
    if (!value) return false

    if (!value || !value.length) return false
    if (value[0] === 'U' || value[0] === 'u') return true
    if (value[0] === 'W' || value[0] === 'w') return true

    var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET'
    var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i
    var nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i
    var str = value.toUpperCase()

    if (str.length === 7) {
      str = '00' + str
    }
    if (str.length === 8) {
      str = '0' + str
    }

    if (!nifRexp.test(str) && !nieRexp.test(str)) return false

    var nie = str
      .replace(/^[X]/, '0')
      .replace(/^[Y]/, '1')
      .replace(/^[Z]/, '2')

    var letter = str.substr(-1)
    var charIndex = parseInt(nie.substr(0, 8)) % 23

    if (validChars.charAt(charIndex) === letter) return true

    return false
    /* eslint-enable */
  },
  validaEmail(email) {
    /* eslint-disable */
    // return true
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    /* eslint-enable */
    return re.test(email)
  },

  goHome() {
    if (Session.getHomeHTML()) {
      router.push('/home');
    } else {
      router.push('/');
    }
  },


  intervaloCortesiaAbierto(t) {
    // esto se fija en un timer desde el componente padre ..
    if (t.enIntervaloCortesia) return true;
    // eval('debugger')
    let now = moment();

    if (!t) return false;
    if (t.calledOutTime) return false;


    let allowedVisitorDelay = (t.servicePoint || {}).allowedVisitorDelay || 15;

    let minutesdiff = Math.abs(moment(t.scheduledServiceTime).diff(now, "minutes"));
    window.console.log(`t.enIntervaloCortesia ${t.enIntervaloCortesia}  allowedVisitorDelay=${allowedVisitorDelay} minutesdiff=${minutesdiff} abierto ${allowedVisitorDelay > minutesdiff}`)

    return allowedVisitorDelay > minutesdiff
  },

  getTeleconfURL() {
    return Session.getTeleconfURL()
  },

  hash(s) {
    s = s + ''
    var hash = 5381, i = s.length
    while (i)
      hash = (hash * 33) ^ s.charCodeAt(--i)
    return hash >>> 0;
  },


  /**
   * Algunas URLs interesantes:
   *  1. In office flow. No solicita datos personales.  http://localhost:8081/?q=21&c=9000
   *  2. Unica oficina. No permite seleccionar otra.    http://localhost:8081/?q=70
   */

  async initPortal(component, calculateNextRoute) {
    let tenantID = component.$route.query.t   // id del dispositivo con el que autenticarse en API
    let queueID = component.$route.query.q    // si se quiere saltar directamente a una oficina
    let channelID = component.$route.query.c    // si la persona ya está en la oficina no se le piden datos personales, etc.
    let lang = component.$route.query.l       // id del lenguaje a seleccionar (coincide con el id de lo que devuelva la variable portal_lang)
    let targetRouteName = component.$route.query.trn

    window.console.log(`Portal init: ${tenantID} ${queueID} ${lang} ${targetRouteName} ${JSON.stringify(Session.getUser())} ${JSON.stringify(Session.store.state)}`)

    if (!(Session.getUser() || {}).id) {
      // window.location.hostname debe darse de alta como un dispositivo en la consola de administracion
      await APIAuth.tryLogin(tenantID || window.location.hostname);
      await this.loadLangs();
      Session.setTenant(Session.getUser().tenant)
    }

    if (lang) {
      document.getElementById(`lang-button-${lang}`).click()
    }

    if (targetRouteName) {
      component.$router.push({ name: targetRouteName })
    }

    if (queueID) {
      let res = await APIPortal.queuesByTenant(Session.getTenant().id, "m");
      let q = window._.filter(res.data || [], q => q.id === +queueID);
      if (!q && !q.length) alert('No se encuentra la oficina ' + queueID)
      let aq = q[0] || Session.getQueue() || Session.getUseSingleQueue()
      if (aq) {
        Session.setQueue(aq)
        Session.setUseSingleQueue(aq)
      }
    }

    if (!calculateNextRoute) return

    if (Session.getUseSingleQueue()) {
      let targetRoute = +(channelID || 0) === this.ATTENCION_OFICINA ? 'InOfficeFlow' : 'SelectService'
      return component.$router.push({ name: targetRoute })
    }
  },

  async loadLangs() {
    let langs = await APIPortal.findProperty("PORTAL_CONFIGURATION");

    // esto es un ripio .. habria que cambiarlo tambien ..
    Session.selectLangCallback = async (f) => {
      await APIPortal.setLanguage(+f.id);
      window.dispatchEvent(new Event('language.changed'));
    }

    try {
      let json = JSON.parse(langs.data.value)
      Session.setConfiguration(json)
      Session.setLanguages(json.languages)
      return json
    } catch (err) {
      window.console.log('No se ha podido cargar los lenguajes del portal.')
    }

  },

  async iniciarVideoconferencia(t) {
    let nt = t;
    t = (await APIPortal.checkinTicket(t.id)).data;

    let roomID = this.hash(t.id);
    let mytoken = nt.teleconfVisitorToken || "visitor";

    window.console.log("roomID:", roomID);
    window.console.log("mytoken:", mytoken);

    let url = this.getTeleconfURL();
    window.console.log("url", url);

    url = url.replace("__roomID__", roomID);
    url = url.replace("__mytoken__", mytoken);

    window.console.log("url>", url);

    window.open(url, "_blank");
  },

  puedoIniciarVideoconferencia(t) {
    // si no es videoconferencia no se puede.
    if ((t.serviceChannel || {}).id !== this.ATTENCION_TELECONF)
      return false;
    window.console.log(`t.calledInTime ${t.calledInTime} t.calledOutTime ${t.calledOutTime}`)
    // mientras esta siendo atendido, puede volver a entrar siempre ..
    if (t.calledInTime && !t.calledOutTime) return true;

    // solo si llega esta dentro del intervalo de cortesia ..
    return this.intervaloCortesiaAbierto(t);
  },


  scrollTo(s) {
    setTimeout(() => {
      let el = document.getElementById(s)

      if (!el) return
      el.scrollIntoView({ behavior: "smooth" });
    }, 1200)
  },


  muestraTicketEmitido(t) {
    Session.setTicket(t);
    Session.setServicePoint(null);
    // Session.setQueue(null);
    // Session.setServiceChannel(null);

    router.push({ name: 'Confirmation' });
  }

}


export default utils
